// Aviso Legal - Legal Notice (LSSI-CE Compliance)
import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const LegalNotice = () => {
    return (
        <div className="legal-container">
            <nav className="legal-nav">
                <Link to="/" className="legal-back">← Volver al inicio</Link>
                <Link to="/" className="legal-logo">
                    <div className="legal-logo-icon">⚡</div>
                    <span className="legal-logo-text">Roadmap<span>Platform</span></span>
                </Link>
            </nav>

            <header className="legal-header">
                <h1>Aviso Legal</h1>
                <p className="legal-subtitle">Información legal sobre el titular de este sitio web</p>
                <span className="legal-updated">Última actualización: Febrero 2026</span>
            </header>

            <main className="legal-content">
                <section className="legal-section">
                    <h2>1. Datos identificativos del titular</h2>
                    <p>En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSI-CE), se facilitan los siguientes datos identificativos del titular de este sitio web:</p>
                    
                    <div className="legal-contact-card">
                        <h4>Datos del Responsable</h4>
                        <div className="contact-item">
                            <span className="contact-icon">🏢</span>
                            <div className="contact-info">
                                <span className="contact-label">Denominación social</span>
                                <span className="contact-value">[NOMBRE O RAZÓN SOCIAL - PENDIENTE]</span>
                            </div>
                        </div>
                        <div className="contact-item">
                            <span className="contact-icon">🆔</span>
                            <div className="contact-info">
                                <span className="contact-label">NIF/CIF</span>
                                <span className="contact-value">[NIF/CIF - PENDIENTE]</span>
                            </div>
                        </div>
                        <div className="contact-item">
                            <span className="contact-icon">📍</span>
                            <div className="contact-info">
                                <span className="contact-label">Domicilio</span>
                                <span className="contact-value">[DIRECCIÓN COMPLETA - PENDIENTE]</span>
                            </div>
                        </div>
                        <div className="contact-item">
                            <span className="contact-icon">📧</span>
                            <div className="contact-info">
                                <span className="contact-label">Email de contacto</span>
                                <span className="contact-value">[EMAIL - PENDIENTE]</span>
                            </div>
                        </div>
                        <div className="contact-item">
                            <span className="contact-icon">📞</span>
                            <div className="contact-info">
                                <span className="contact-label">Teléfono</span>
                                <span className="contact-value">[TELÉFONO - PENDIENTE]</span>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="legal-section">
                    <h2>2. Objeto del sitio web</h2>
                    <p>Este sitio web, accesible desde roadmap.fixarr.es (en adelante, "la Plataforma"), tiene como objeto proporcionar una herramienta de gestión de proyectos y roadmaps para el desarrollo de software, permitiendo a los usuarios:</p>
                    <ul>
                        <li>Crear y gestionar roadmaps de proyectos</li>
                        <li>Organizar tareas y fases de desarrollo</li>
                        <li>Conectar con servicios externos (GitHub, Supabase, etc.)</li>
                        <li>Realizar copias de seguridad de sus proyectos</li>
                        <li>Acceder a guías y recursos de aprendizaje</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>3. Condiciones de uso</h2>
                    <p>El acceso y uso de este sitio web atribuye la condición de USUARIO, que acepta, desde dicho acceso y/o uso, las presentes condiciones generales de uso.</p>
                    
                    <h3>3.1 Obligaciones del usuario</h3>
                    <p>El usuario se compromete a:</p>
                    <ul>
                        <li>Hacer un uso adecuado de los contenidos y servicios ofrecidos</li>
                        <li>No realizar actividades ilícitas, ilegales o contrarias a la buena fe</li>
                        <li>No difundir contenidos o propaganda de carácter racista, xenófobo, pornográfico, de apología del terrorismo o atentatorio contra los derechos humanos</li>
                        <li>No provocar daños en los sistemas físicos y lógicos de la Plataforma</li>
                        <li>No intentar acceder a áreas restringidas de los sistemas informáticos</li>
                        <li>No suplantar la identidad de otros usuarios</li>
                    </ul>

                    <h3>3.2 Uso de credenciales</h3>
                    <p>El usuario es responsable de mantener la confidencialidad de sus credenciales de acceso. Cualquier actividad realizada desde su cuenta será responsabilidad del titular de la misma.</p>
                </section>

                <section className="legal-section">
                    <h2>4. Propiedad intelectual e industrial</h2>
                    <p>Todos los contenidos del sitio web, incluyendo pero no limitado a textos, imágenes, gráficos, logotipos, iconos, software y cualquier otro material, están protegidos por derechos de propiedad intelectual e industrial.</p>
                    
                    <p>Quedan reservados todos los derechos. Queda prohibida la reproducción, distribución, transformación, comunicación pública y cualquier otra forma de explotación no autorizada expresamente.</p>

                    <div className="legal-info-box">
                        <p><strong>Contenido del usuario:</strong> Los proyectos y datos que el usuario crea y almacena en la Plataforma son propiedad exclusiva del usuario. La Plataforma no reclama ningún derecho de propiedad sobre el contenido generado por los usuarios.</p>
                    </div>
                </section>

                <section className="legal-section">
                    <h2>5. Exclusión de garantías y responsabilidad</h2>
                    <p>El titular no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier naturaleza que pudieran ocasionar, a título enunciativo:</p>
                    <ul>
                        <li>Errores u omisiones en los contenidos</li>
                        <li>Falta de disponibilidad del sitio web</li>
                        <li>Transmisión de virus o programas maliciosos a través de los contenidos</li>
                        <li>Uso ilícito, negligente, fraudulento o contrario a estas condiciones</li>
                        <li>Falta de utilidad, adecuación o validez del sitio web para necesidades específicas</li>
                    </ul>
                    
                    <p>El servicio se proporciona "tal cual" (AS IS), sin garantías de ningún tipo, expresas o implícitas.</p>
                </section>

                <section className="legal-section">
                    <h2>6. Enlaces a terceros</h2>
                    <p>Este sitio web puede contener enlaces a sitios de terceros (GitHub, Supabase, Vercel, etc.). El titular no se responsabiliza del contenido, políticas de privacidad o prácticas de dichos sitios.</p>
                    <p>La inclusión de estos enlaces no implica aprobación o asociación con los operadores de dichos sitios.</p>
                </section>

                <section className="legal-section">
                    <h2>7. Modificaciones</h2>
                    <p>El titular se reserva el derecho de modificar, en cualquier momento y sin previo aviso, la presentación, configuración y contenido del sitio web, así como las condiciones requeridas para su acceso y/o uso.</p>
                </section>

                <section className="legal-section">
                    <h2>8. Legislación aplicable y jurisdicción</h2>
                    <p>Para la resolución de todas las controversias o cuestiones relacionadas con el presente sitio web o de las actividades en él desarrolladas, será de aplicación la legislación española, a la que se someten expresamente las partes, siendo competentes para la resolución de todos los conflictos derivados o relacionados con su uso los Juzgados y Tribunales del domicilio del usuario en España, o los Juzgados y Tribunales de la ciudad correspondiente al domicilio del titular.</p>
                </section>

                <section className="legal-section">
                    <h2>9. Contacto</h2>
                    <p>Para cualquier consulta relacionada con este Aviso Legal, puede ponerse en contacto con nosotros a través de:</p>
                    <ul>
                        <li>Página de contacto: <Link to="/contact">roadmap.fixarr.es/contact</Link></li>
                        <li>Email: [EMAIL - PENDIENTE]</li>
                    </ul>
                </section>
            </main>

            <footer className="legal-footer">
                <div className="legal-footer-links">
                    <Link to="/privacy-policy">Política de Privacidad</Link>
                    <Link to="/cookies">Política de Cookies</Link>
                    <Link to="/terms">Términos y Condiciones</Link>
                    <Link to="/contact">Contacto</Link>
                </div>
                <p>© 2026 Roadmap Platform. Parte del ecosistema FIXARR.</p>
            </footer>
        </div>
    );
};

export default LegalNotice;
